import React from 'react';
import { useTranslation } from 'react-i18next';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coldarkDark as scheme } from 'react-syntax-highlighter/dist/esm/styles/prism';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Iconify from '../../theme/iconify/iconify';

function Code({ children, match, rest }) {
    const [copied, setCopied] = React.useState(false);

    const { t } = useTranslation();

    const copyToClipboard = () => {
        navigator.clipboard.writeText(children);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    }

    return (
        <>
            <div style={{
                borderRadius: '8px',
                background: 'rgb(17, 27, 39)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '4px',
                    background: '#080c12',
                    paddingRight: '12px',
                    paddingLeft: '12px',
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px'
                }}>
                    <Typography
                        sx={{
                            color: 'background.neutral',
                            fontWeight: '300',
                            fontSize: '0.75rem',
                        }}>
                        {match[1]}
                    </Typography>
                    <Button
                        variant=''
                        startIcon={<Iconify icon={copied ? 'eva:checkmark-outline' : 'bx:copy'} width={copied ? 16 : 12} />}
                        onClick={() => copyToClipboard()}
                        sx={{
                            color: 'background.neutral',
                            fontWeight: '300',
                            fontSize: '0.75rem',
                            px: 0,
                            py: 0
                        }}
                    >
                        {copied ? t('chat.message.buttons.copied') : t('chat.message.buttons.copy')}
                    </Button>
                </div>
                <SyntaxHighlighter
                    className='mISLec_chat_code'
                    {...rest}
                    PreTag='div'
                    children={String(children).replace(/\n$/, '')}
                    language={match[1]}
                    style={scheme}
                />
            </div>
        </>
    );
}

export default Code;